import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import noop from "lodash/noop";
import { Checkbox, Divider, Row, Col, Input, Button, Card } from "antd";
// import { useDrag } from "react-dnd";
import "styles/table.css";

const CheckboxGroup = Checkbox.Group;

const DraggableOption = ({checkedColumns, _, columnLimit}) => {
    // const [{isDragging}, drag] = useDrag({
    //     item: { type: _.key },
    //     collect: monitor => ({
    //         isDragging: !!monitor.isDragging(),
    //     }),
    // });
    
    return (
        <Card 
            // ref={drag} 
            className={"padless-card p-7 mb-7"} 
        >
            {/* <div
                draggable
                onDragStart={(e) => onDragStart(e, _)}
            > */}
            <Checkbox 
                disabled={checkedColumns && checkedColumns.size >= columnLimit && !checkedColumns.find(__ => __.key === _.key)}
                value={_.key}
            >
                {_.title}
            </Checkbox>
            {/* </div> */}
        </Card>
    );
};

DraggableOption.propTypes = {
    checkedColumns: PropTypes.object, 
    _: PropTypes.object, 
    columnLimit: PropTypes.number
};

class TableColumnSelector extends React.Component {
    state = {
        newField: null
    };
    addNewField = () => {
        this.props.addNewField(this.state.newField);
    };
    onSelect = (...args) => {
        this.props.onSelect(args[0]);
    }
    render() {
        const {
            checkedColumns,
            columns,
            allSelectorLabel,
            showAddNewFieldBtn,
            columnLimit
        } = this.props;
        return (
            <div
                className={"bg-white p-5"}
                style={{
                    minWidth: "250px"
                }}>
                {columnLimit > 0 ? null : 
                    (
                        <React.Fragment>
                            <Checkbox
                                checked={checkedColumns.size === columns.size}
                                indeterminate={checkedColumns.size < columns.size}
                                onChange={() => this.onSelect([], "select_all")}>
                                {allSelectorLabel}
                            </Checkbox>
                            <Divider type={"horizontal"} style={{ margin: "5px 0px" }} />
                        </React.Fragment>
                    )
                }
                <CheckboxGroup
                    onChange={this.onSelect}
                    value={checkedColumns
                        .map(_ => _.key)
                        .toList()
                        .toArray()}
                    className={"d-flex flex-column"}
                    style={{ overflow: "scroll" }}
                >
                    {columns.toList().toArray().map((_, k) => 
                        <DraggableOption 
                            index={k}
                            key={k}
                            checkedColumns={checkedColumns} 
                            _={_}
                            columnLimit={this.props.columnLimit}
                        />
                    )}
                </CheckboxGroup>
                {columnLimit > 0 ?
                    (
                        <React.Fragment>
                            <Divider type={"horizontal"} style={{ margin: "5px 0px" }} />
                            <div style={{ fontSize: "12px"}}> Maximum of 10 columns can be selected</div>
                        </React.Fragment>
                    ) : null
                }
                {showAddNewFieldBtn ? (
                    <Row>
                        <Col span={8}>
                            <Input
                                type={"text"}
                                onChange={val => {
                                    this.setState({
                                        newField: val.target.value
                                    });
                                }}
                            />
                        </Col>
                        <Col span={8}>
                            <Button onClick={this.addNewField}>
                                Add New Field
                            </Button>
                        </Col>
                    </Row>
                ) : null}
            </div>
        );
    }
}

TableColumnSelector.propTypes = {
    //Required Props
    onSelect: PropTypes.func.isRequired,
    columns: PropTypes.object.isRequired,
    //Optional Props
    checkedColumns: PropTypes.object,
    showAddNewFieldBtn: PropTypes.bool,
    addNewField: PropTypes.func,
    allSelectorLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    columnLimit: PropTypes.oneOfType([PropTypes.func, PropTypes.number])
};

TableColumnSelector.defaultProps = {
    onSelect: noop,
    columns: new Map({}),
    checkedColumns: new Map({}),
    allSelectorLabel: "All",
    showAddNewFieldBtn: false
};

export default TableColumnSelector;
